import { c as _c } from "react/compiler-runtime";
import { BLOGS_API } from 'modules/blogs/api/blog-api';
import { BlogInterface } from 'modules/blogs/types/blog-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import useSWR from 'swr';
interface UseBlogInterface {
  id: string;
}
export function useBlog(t0) {
  const $ = _c(7);
  const {
    id
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] !== id || $[2] !== user) {
    t2 = () => {
      if (user) {
        return `${BLOGS_API}/${id}`;
      }
      return null;
    };
    $[1] = id;
    $[2] = user;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    data: blog,
    mutate: blogMutate
  } = useSWR(t2, fetcher);
  let t3;
  if ($[4] !== blog || $[5] !== blogMutate) {
    t3 = {
      blog,
      blogMutate
    };
    $[4] = blog;
    $[5] = blogMutate;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}